"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_1 = require("react");
const mobx_react_1 = require("mobx-react");
const hui_1 = require("@mit/hui");
const ContactCaseCard_1 = __importDefault(require("./ContactCaseCard"));
const ContactTracingApi_1 = __importDefault(require("../../api/ContactTracingApi"));
const PeopleController_1 = __importDefault(require("../../api/PeopleController"));
const contactTracingStore_1 = __importDefault(require("../../stores/contactTracingStore"));
const ContactTracingListComponent = ({ loading, roles, covidNav }) => {
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [isError, setError] = (0, react_1.useState)(false);
    const [showModal, setModal] = (0, react_1.useState)(false);
    const [tabs, setTabs] = (0, react_1.useState)("notCompleted");
    // const [cases, setCasses] = useState<CaseResponse[]>([]);
    const [timeout, setSearchTimeout] = (0, react_1.useState)(0);
    const [selectedPersonResident, setSelectedPersonResident] = (0, react_1.useState)(false);
    const [isSearchLoading, setSearchLoading] = (0, react_1.useState)(false);
    const [selectedPerson, setSelectedPerson] = (0, react_1.useState)({});
    const [searchData, setSearchData] = (0, react_1.useState)([]);
    const [postingCase, setPostingCase] = (0, react_1.useState)(false);
    const [validationError, setValidationError] = (0, react_1.useState)("");
    const [showFilter, setShowFilter] = (0, react_1.useState)(false);
    const [filter, setFilter] = (0, react_1.useState)("");
    const [keyword, setKeyword] = (0, react_1.useState)("");
    const [page, setPage] = (0, react_1.useState)(0);
    const [rowsPerPage, setRowsPerPage] = (0, react_1.useState)(5);
    const cases = contactTracingStore_1.default.useStoreState((state) => state.casesList);
    const setCasses = contactTracingStore_1.default.useStoreActions((actions) => actions.setCasesList);
    (0, react_1.useEffect)(() => {
        setLoading(loading);
    }, [loading]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        if (!isEmpty(cases) && !(roles === null || roles === void 0 ? void 0 : roles.roles.includes("dining")) && !(roles === null || roles === void 0 ? void 0 : roles.roles.includes("student_support"))) {
            if (tabs === "notCompleted") {
                setPage(0);
                const statusID = (_a = covidNav === null || covidNav === void 0 ? void 0 : covidNav.contactTracingStatus.find((x) => x.status_name === "Not Completed")) === null || _a === void 0 ? void 0 : _a.status_id;
                fetchCases(false, false, statusID);
            }
            if (tabs === "inProgress") {
                setPage(0);
                const statusID = (_b = covidNav === null || covidNav === void 0 ? void 0 : covidNav.contactTracingStatus.find((x) => x.status_name === "In Progress")) === null || _b === void 0 ? void 0 : _b.status_id;
                fetchCases(false, false, statusID);
            }
            if (tabs === "completed") {
                setPage(0);
                let statusID = (_c = covidNav === null || covidNav === void 0 ? void 0 : covidNav.contactTracingStatus.find((x) => x.status_name === "Completed")) === null || _c === void 0 ? void 0 : _c.status_id;
                if (statusID === undefined) {
                    statusID = 3;
                }
                fetchCases(false, false, statusID);
            }
            if (tabs === "residents") {
                setPage(0);
                fetchCases(true, false);
            }
            if (tabs === "all") {
                setPage(0);
                fetchCases(false, false);
            }
        }
        else {
            setPage(0);
            fetchCases(false, false);
        }
    }, [tabs]);
    const getStatusId = () => {
        var _a, _b, _c;
        if ((roles === null || roles === void 0 ? void 0 : roles.roles.includes("dining")) || (roles === null || roles === void 0 ? void 0 : roles.roles.includes("student_support")))
            return undefined;
        if (tabs === "notCompleted") {
            const statusID = (_a = covidNav === null || covidNav === void 0 ? void 0 : covidNav.contactTracingStatus.find((x) => x.status_name === "Not Completed")) === null || _a === void 0 ? void 0 : _a.status_id;
            return statusID;
        }
        if (tabs === "inProgress") {
            const statusID = (_b = covidNav === null || covidNav === void 0 ? void 0 : covidNav.contactTracingStatus.find((x) => x.status_name === "In Progress")) === null || _b === void 0 ? void 0 : _b.status_id;
            return statusID;
        }
        if (tabs === "completed") {
            let statusID = (_c = covidNav === null || covidNav === void 0 ? void 0 : covidNav.contactTracingStatus.find((x) => x.status_name === "Completed")) === null || _c === void 0 ? void 0 : _c.status_id;
            if (statusID === undefined) {
                statusID = 3;
            }
            return statusID;
        }
        if (tabs === "all") {
            return undefined;
        }
    };
    const fetchCases = (dsl, silent, status_id) => {
        !silent && setLoading(true);
        ContactTracingApi_1.default.fetchCases(dsl, status_id).then((casesResponse) => {
            if (casesResponse.error) {
                setLoading(false);
                //todo: handle error
            }
            else {
                if (casesResponse.items) {
                    setLoading(false);
                    setCasses(casesResponse.items);
                    //peopleStore?.setContactTracingList(casesResponse.items);
                }
            }
        });
    };
    const checkResident = (person) => {
        PeopleController_1.default.fetchPersonAws(person.mitId ? person.mitId : person.kerberosId).then((response) => {
            if (response) {
                if (response.detail.resident)
                    setSelectedPersonResident(true);
            }
        });
    };
    const handleSearch = (query, element) => {
        if (timeout) {
            clearTimeout(timeout);
        }
        setSearchLoading(true);
        setSearchTimeout(setTimeout(() => {
            PeopleController_1.default.fetchPeopleAws(query).then((peopleResultsResponse) => {
                if (peopleResultsResponse.people) {
                    setSearchLoading(false);
                    let newSearchData = peopleResultsResponse.people.map((itm) => {
                        return {
                            icon: "user",
                            text: `${itm.displayName} (${itm.kerberosId})`,
                            secondaryText: "",
                            onClick: () => {
                                checkResident(itm);
                                setSelectedPerson(itm);
                            },
                            tertiaryText: "",
                            id: itm.kerberosId,
                        };
                    });
                    setSearchData(newSearchData);
                    setValidationError("");
                    setSearchLoading(false);
                }
            });
        }, 500));
    };
    const isEmpty = (obj) => {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }
        return JSON.stringify(obj) === JSON.stringify({});
    };
    if (isError)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Oops.. something went wrong", type: hui_1.ErrorType.Generic });
    let navItems = [];
    if (!(roles === null || roles === void 0 ? void 0 : roles.roles.includes("dining")) && !(roles === null || roles === void 0 ? void 0 : roles.roles.includes("student_support")))
        navItems = [
            {
                icon: "",
                iconOnly: false,
                text: "Completed",
                state: tabs === "completed" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
                onClick: () => {
                    setTabs("completed");
                },
            },
            {
                icon: "",
                iconOnly: false,
                text: "Not Completed",
                state: tabs === "notCompleted" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
                onClick: () => {
                    setTabs("notCompleted");
                },
            },
            {
                icon: "",
                iconOnly: false,
                text: "In Progress",
                state: tabs === "inProgress" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
                onClick: () => {
                    setTabs("inProgress");
                },
            },
            {
                icon: "",
                iconOnly: false,
                text: "All cases",
                state: tabs === "all" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
                onClick: () => {
                    setTabs("all");
                },
            },
        ];
    const setFilterValue = () => {
        setShowFilter(false);
        setFilter(keyword);
        setPage(0);
    };
    const clearFilterValue = () => {
        setShowFilter(false);
        setFilter("");
        setPage(0);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (val) => {
        setRowsPerPage(parseInt(val.text, 10));
        setPage(0);
    };
    const renderHeader = () => {
        if ((roles === null || roles === void 0 ? void 0 : roles.roles.includes("dining")) || (roles === null || roles === void 0 ? void 0 : roles.roles.includes("student_support"))) {
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row no-gutters" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-2" }, { children: "Person" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col" }, { children: "Email" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col" }, { children: "Phone" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col" }, { children: "Vaccine Status" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col" }, { children: "Case Number" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col" }, { children: "Case Type" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col" }, { children: "Case Status" }))] })));
        }
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row no-gutters" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-5" }, { children: "Person" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-1" }, { children: "Contact Date" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-6 text-right" }, { children: (roles === null || roles === void 0 ? void 0 : roles.roles.includes("medical")) && (0, jsx_runtime_1.jsx)(hui_1.Button, { icon: "plus", text: "Add new Case", type: hui_1.ButtonType.Ghost | hui_1.ButtonType.Secondary, onClick: () => setModal(true), padded: true }) }))] })));
    };
    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "contacttracingtable" }, { children: [(0, jsx_runtime_1.jsx)(hui_1.NavBar, { tabs: navItems, type: hui_1.NavBarTypes.Text, itemAlignment: hui_1.ItemAlignment.Left }), (0, jsx_runtime_1.jsx)(hui_1.Button, { icon: "filter", text: "Filter", type: hui_1.ButtonType.Small, onClick: () => setShowFilter(true) }), renderHeader(), (0, jsx_runtime_1.jsx)("hr", {}), isLoading && (0, jsx_runtime_1.jsx)(hui_1.AdvancedTable, { columns: [], items: [], showExportButton: false, showFilterButton: true, isLoading: isLoading, theme: "medical" }), !isLoading && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [cases.length > 0 &&
                                cases
                                    .filter((itm) => itm.person.display_name.toLowerCase().includes(filter.toLowerCase()))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((itm, i) => {
                                    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(ContactCaseCard_1.default, { caseData: itm, fetchCases: () => fetchCases(tabs === "residents" ? true : false, true, getStatusId()), setIsLoading: (value) => setLoading(value) }, itm.case_guid) }));
                                }), (0, jsx_runtime_1.jsx)(hui_1.TablePagination, { rowsPerPageOptions: [5, 10, 25], component: "div", count: cases.filter((itm) => itm.person.display_name.toLowerCase().includes(filter.toLowerCase())).length, rowsPerPage: rowsPerPage, page: page, onChangePage: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage })] })), !isLoading && cases.length === 0 && (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, type: hui_1.ErrorType.NoData, message: "No active cases data available" })] })), (0, jsx_runtime_1.jsx)(hui_1.Drawer, { contentAriaLabel: "Contact Tracing Filter List", show: showFilter, type: hui_1.DrawerType.Left, size: hui_1.DrawerSize.Small, onClose: () => setShowFilter(false), themedColor: "medical", header: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: "Filter", type: hui_1.TextType.Heading4, icon: "" }), contents: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "fitler-container" }, { children: [(0, jsx_runtime_1.jsx)(hui_1.Text, { type: hui_1.TextType.Body, content: "Name" }), (0, jsx_runtime_1.jsx)(hui_1.Textbox, { name: "", startIcon: "search", placeholderText: "Search", value: keyword, onChange: (e) => setKeyword(e.currentTarget.value), type: 2 }), (0, jsx_runtime_1.jsx)(hui_1.Spacer, { size: "2" }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "btn-padded" }, { children: [(0, jsx_runtime_1.jsx)(hui_1.Button, { text: "Filter", onClick: setFilterValue }), (0, jsx_runtime_1.jsx)(hui_1.Button, { text: "Clear", onClick: clearFilterValue, type: hui_1.ButtonType.Ghost | hui_1.ButtonType.Secondary })] }))] })), footer: [] }), (0, jsx_runtime_1.jsx)(hui_1.TemplateModal, { body: (0, jsx_runtime_1.jsxs)("div", { children: [validationError && (0, jsx_runtime_1.jsx)(hui_1.Alert, { text: validationError, type: "error" }), (0, jsx_runtime_1.jsx)(hui_1.Form, Object.assign({ formValidationTrigger: "onBlur" }, { children: (methods) => {
                                const postCase = () => {
                                    methods.trigger().then((valid) => {
                                        //Validation
                                        if (!valid)
                                            return;
                                        let data = methods.getValues();
                                        if (valid && data.date) {
                                            setPostingCase(true);
                                            let body = {
                                                case_type_id: 2,
                                                case_date: data.date,
                                                status_id: 1,
                                                medical_test_guid: null,
                                                person: {
                                                    display_name: selectedPerson === null || selectedPerson === void 0 ? void 0 : selectedPerson.displayName,
                                                    mit_id: selectedPerson === null || selectedPerson === void 0 ? void 0 : selectedPerson.mitId,
                                                    kerberos: selectedPerson === null || selectedPerson === void 0 ? void 0 : selectedPerson.kerberosId,
                                                },
                                            };
                                            ContactTracingApi_1.default.postCase(body).then((response) => {
                                                if (response.error) {
                                                    //Todo Error
                                                    setPostingCase(false);
                                                    setModal(false);
                                                }
                                                else {
                                                    if (response.items) {
                                                        PeopleController_1.default.putResident(selectedPerson === null || selectedPerson === void 0 ? void 0 : selectedPerson.mitId, data.food ? data.food : false);
                                                        setPostingCase(false);
                                                        setModal(false);
                                                        fetchCases(false, false, getStatusId());
                                                    }
                                                }
                                            });
                                        }
                                        else {
                                            if (!data.date)
                                                setValidationError("Please select a valid date");
                                        }
                                    });
                                };
                                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hui_1.FormContainer, Object.assign({ methods: methods, id: "internalForm", formValidationTrigger: "onBlur" }, { children: (0, jsx_runtime_1.jsx)(hui_1.GridContainer, { children: (0, jsx_runtime_1.jsxs)(hui_1.LayoutColumn, Object.assign({ colSize: 12 }, { children: [(0, jsx_runtime_1.jsx)(hui_1.FormField, { labelDisplay: "ontop", label: "Name & Surname", editor: "autocomplete", items: searchData, properties: { onSearch: handleSearch, isBusy: isSearchLoading, searchOptions: { placeholderText: "Search by name or kerberos id", name: "" } }, required: true, id: "nameSurname" }), (0, jsx_runtime_1.jsx)(hui_1.FormField, { labelDisplay: "ontop", label: "Date of contact", editor: "calendar", required: true, id: "date" }), (roles === null || roles === void 0 ? void 0 : roles.roles.includes("medical")) && selectedPersonResident && ((0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "food", editor: "checkbox", label: "Have food delivered to resident", labelDisplay: "ontop" }))] })) }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row pt-4 pb-4" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "col-12 text-center" }, { children: [(0, jsx_runtime_1.jsx)(hui_1.Button, { text: "Add Case", isBusy: postingCase, state: postingCase ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled, icon: "", onClick: () => postCase(), type: hui_1.ButtonType.Ghost | hui_1.ButtonType.Secondary, title: "back" }), "\u00A0\u00A0", (0, jsx_runtime_1.jsx)(hui_1.Button, { text: "Cancel", onClick: () => {
                                                            setModal(false);
                                                            setValidationError("");
                                                        } })] })) }))] }));
                            } }))] }), bodyAlignment: hui_1.TemplateModalAlignment.Center, footer: (0, jsx_runtime_1.jsx)("div", {}), header: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: "Add new case", type: hui_1.TextType.Heading4 }), name: "newCase", show: showModal, onClose: () => {
                    setModal(false);
                    setValidationError("");
                } })] }));
};
const ContactTracingList = (0, mobx_react_1.inject)("covidNav", "holds", "roles", "searchUser", "peopleStore")((0, mobx_react_1.observer)(ContactTracingListComponent));
exports.default = ContactTracingList;
